module.exports = __webpack_public_path__ + "static/media/yuandanCore1.f1a24c21.png";